(function() {
    'use strict';

    angular.module('app').controller('HarmonogramsCtrl', [
        '$scope',
        '$http',
        '$translate',
        '$ngConfirm',
        'toaster',
        '$q',
        '$localStorage',
        '$cookies',
        '$state',
        '$stateParams',
        '$timeout',
        'csLanguage',
        function(
            $scope,
            $http,
            $translate,
            $ngConfirm,
            toaster,
            $q,
            $localStorage,
            $cookies,
            $state,
            $stateParams,
            $timeout,
            csLanguage
        ) {
            var REFRESH_TIME_IN_MILISECONDS = 10000;

            $scope.LIST_TAB = 'vehicles';
            $scope.SCHEDULE_TAB = 'schedules';
            $scope.HISTORY_TAB = 'history';
            $scope.CARDS_TAB = 'cards';
            $scope.FILES_TAB = 'files';

            $scope.tab = $stateParams.tab;

            $scope.changeTab = function(v) {
                $scope.tab = v;

                var url = $state.current.name.split('.');
                url.pop();
                url = url.join('.') + '.' + v;

                $state.go(url, {}, { reload: false, notify: false });

                if ($scope.isTab($scope.CARDS_TAB)) {
                    var company = $scope.companies.selected;
                    if (company && $scope.cards.loaded !== company.id) {
                        getCompanyCards(company.id);
                    }
                }

                return getCompanyFiles().then(function() {
                    return applyCompanyFilesFilters();
                });
            };

            $scope.isTab = function(tab) {
                return $scope.tab === tab;
            };

            $scope.loading = false;
            $scope.expanded = false;

            $scope.form = {};
            $scope.initialForm = angular.copy($scope.form);

            $scope.mapStatusToIcon = function(status) {
                var icons = {
                    1: 'fas fa-list-ol',
                    2: 'fas fa-hourglass-start',
                    3: 'fas fa-cloud-upload-alt ww-red',
                    4: '',
                    8: '',
                    9: '',
                    10: '',
                    11: '',
                    12: 'fas fa-user-shield ww-red',
                    13: '',
                    14: 'fas fa-check-square ww-green',
                    15: 'fas fa-calendar-times ww-red',
                    21: '',
                    22: '',
                    23: '',
                    24: '',
                    100: 'fas fa-chevron-circle-right',
                    101: '',
                    110: '',
                    111: '',
                    112: '',
                    120: 'fas fa-shuttle-van ww-red',
                    121: 'fas fa-unlink ww-red',
                    122: '',
                    123: '',
                    130: '',
                    131: '',
                    132: '',
                    135: '',
                    136: '',
                };

                if (icons[status] !== void 0) {
                    return icons[status];
                }

                return 'fas';
            };

            var reconnect = function() {
                var stored = $scope.app.user.userSettings.harmonograms;

                $scope.auth.user = stored.login;
                $scope.auth.password = stored.password;

                $scope.auth.authorize();
            };

            var interceptor = function(method, action, payload) {
                var deferred = $q.defer();

                if ($scope.hanged) {
                    deferred.reject([]);
                    return deferred.promise;
                }

                var config = {
                    headers: {
                        'X-CSRF-TOKEN': $localStorage.csrf,
                        Accept: 'application/json, text/plain, */*',
                        'Content-Type': 'application/json',
                        jwt_access: $cookies.get('jwt_access'),
                    },
                };

                var p1 = payload;
                var p2 = config;

                if (['get', 'head', 'jsonp', 'delete'].indexOf(method) !== -1) {
                    p1 = config;
                    p2 = undefined;
                }
                action = '/api/harmonogram' + action;

                $http[method](action, p1, p2).then(
                    function(response) {
                        deferred.resolve(response);
                    },
                    function(error) {
                        if (error.status === 401) {
                            delete $localStorage.csrf;

                            $cookies.remove('jwt_access');
                            /**
                             * automatically reconnect
                             */
                            $scope.hanged = true;
                            reconnect();
                        }

                        deferred.reject(error);
                    }
                );

                return deferred.promise;
            };

            $scope.hanged = false;

            $scope.authorized = isAuthorized();
            $scope.auth = {
                user: '',
                password: '',
                authorize: function() {
                    var endpoint = '/api/harmonogram/auth';
                    var payload = {
                        login: this.user,
                        password: this.password,
                    };

                    return $http.post(endpoint, payload).then(
                        function(response) {
                            var data = response.data.data;
                            $localStorage.csrf = data.csrf;

                            var expiration = new Date();
                            expiration.setDate(expiration.getDate() + 365);

                            $cookies.put('jwt_access', data.cookies[0].Value, {
                                expires: expiration,
                            });

                            $state.go('app.harmonograms.vehicles', {}, { reload: true });

                            $scope.loading = false;
                            $scope.hanged = false;
                        },
                        function() {
                            toaster.error(
                                $translate.instant('general.toastr.error.header'),
                                $translate.instant('harmonograms.toastr.error.auth')
                            );

                            delete $localStorage.csrf;
                            $cookies.remove('jwt_access');

                            $scope.loading = false;
                            $scope.hanged = false;
                        }
                    );
                },
                signOut: function() {
                    function logout() {
                        delete $localStorage.csrf;
                        $cookies.remove('jwt_access');

                        $state.go('app.harmonograms.vehicles', {}, { reload: true });
                    }

                    var endpoint = '/api/harmonogram/auth';
                    var config = {
                        headers: {
                            'X-CSRF-TOKEN': $localStorage.csrf,
                            Accept: 'application/json, text/plain, */*',
                            'Content-Type': 'application/json',
                            jwt_access: $cookies.get('jwt_access'),
                        },
                    };
                    $http.delete(endpoint, config).then(
                        function() {
                            logout();
                        },
                        function() {
                            logout();
                        }
                    );
                },
            };

            function isAuthorized() {
                return ($localStorage || {}).csrf !== void 0;
            }

            var Company = function(data) {
                var self = this;
                Object.keys(data).forEach(function(p) {
                    self[p] = data[p];
                });
            };

            var Vehicle = function(data) {
                var self = this;
                Object.keys(data).forEach(function(p) {
                    self[p] = data[p];
                });
            };

            function getChooseObjects(choose, list, primary) {
                var result = {};
                angular.forEach(Object.keys(choose), function(key, index) {
                    if (choose[key]) {
                        angular.forEach(list, function(o) {
                            if (o[primary] === Number(key)) {
                                result[Number(key)] = o;
                            }
                        });
                    }
                });

                return result;
            }

            $scope.schedules = {
                ungrouped: {},
                list: {},
                selected: null,
                choose: {},
            };
            $scope.initialSchedules = angular.copy($scope.schedules);

            $scope.companies = {
                list: [],
                selected: null,
            };

            $scope.vehicles = {
                list: [],
                selected: null,
                choose: {},
            };
            $scope.initialVehicles = angular.copy($scope.vehicles);

            $scope.technicals = {
                list: [],
                loaded: false,
            };

            $scope.scheduleGroups = {
                list: [],
            };

            $scope.histories = [];
            $scope.files = [];
            $scope.filteredFiles = [];
            $scope.statuses = [];

            $scope.cards = {
                list: [],
                loaded: false,
            };

            $scope.filters = {
                vehicles: {
                    search: '',
                },
                schedules: {
                    vehicle: null,
                },
                history: {
                    start: moment().startOf('day'),
                    end: moment().endOf('day'),
                },
                files: {
                    vehicle: null,
                    start: moment()
                        .startOf('day')
                        .subtract(1, 'months'),
                    end: moment().endOf('day'),
                },
            };

            $scope.isEmptyObject = function(o) {
                var result = true;
                angular.forEach(Object.keys(o), function(key, index) {
                    if (o[key]) {
                        result = false;
                    }
                });
                return result;
            };

            function pad(n, width, z) {
                z = z || '0';
                n = n + '';
                return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
            }

            function convertAmountToBinary(amount) {
                var bin = (amount >>> 0).toString(2);
                return pad(bin, 6);
            }

            $scope.isInBinarySet = function(num, amount) {
                var bin = convertAmountToBinary(amount);
                return bin[num] !== '0';
            };

            $scope.getPeriodNumByBinary = function(amount) {
                var bin = convertAmountToBinary(amount);
                bin = bin
                    .split('')
                    .reverse()
                    .join('');

                var result = null;
                for (var i = 0; i < 6; i++) {
                    if (bin[i] !== '0') {
                        result = i;
                    }
                }
                return result + 1;
            };

            function resetLoadedData() {
                $scope.vehicles = angular.copy($scope.initialVehicles);
                $scope.schedules = angular.copy($scope.initialSchedules);

                $scope.histories = [];
                $scope.files = [];
            }

            function changeCompany(company) {
                $scope.companies.selected = company;
                resetLoadedData();

                return getVehicles(company.id).then(function() {
                    getCompanyScheduleGroups(company.id).then(function() {
                        getCompanySchedules(company.id);
                    });
                    getCompanyCards(company.id);

                    return getVehiclesStats(company.id);
                });
            }

            $scope.goToVehicleSchedules = function(id) {
                $scope.filters.schedules.vehicle = { id: id };
                $scope.onChangeVehicleInShedules();
                $scope.changeTab($scope.SCHEDULE_TAB);
            };

            function changeVehicle(vehicle) {
                $scope.vehicles.selected = vehicle;
                return getVehicleHistories($scope.companies.selected, vehicle, false).then(function(list) {
                    $scope.histories = list;
                });
            }

            function getVehicleHistories(company, vehicle, dates) {
                var filters = $scope.filters.history;

                var endpoint = '/companies/' + company.id + '/vehicles/' + vehicle.id + '/histories';
                var from = dates ? dates.from : moment(filters.start).unix();
                var to = dates ? dates.to : moment(filters.end).unix();

                endpoint += '?date_from=' + from + '&date_to=' + to;

                return interceptor('get', endpoint).then(
                    function(response) {
                        var list = (response.data || {}).data;

                        list = list !== void 0 ? list : [];
                        list = assignShedulesVehicle($scope.vehicles.list, list);

                        return list;
                    },
                    function() {
                        return [];
                    }
                );
            }

            function assignShedulesVehicle(vehicles, shedules) {
                return shedules.map(function(o) {
                    var vehicle = null;

                    angular.forEach(vehicles, function(v) {
                        if (v.id === o.vehicleid) {
                            vehicle = v;
                        }
                    });

                    o.Vehicle = vehicle;

                    return o;
                });
            }

            $scope.exportHistory = function(filename, rows) {
                var processRow = function(row) {
                    var finalVal = '';
                    for (var j = 0; j < row.length; j++) {
                        var innerValue = row[j] === null ? '' : row[j].toString();
                        if (row[j] instanceof Date) {
                            innerValue = row[j].toLocaleString();
                        }
                        var result = innerValue.replace(/"/g, '""');
                        if (result.search(/("|,|\n)/g) >= 0) result = '"' + result + '"';
                        if (j > 0) finalVal += ',';
                        finalVal += result;
                    }
                    return finalVal + '\n';
                };

                rows = [['Company', 'Vehicle', 'DateTime', 'State', 'StateCode']];
                filename = moment().format('YYYYMMDDHHmmss') + '.csv';

                angular.forEach($scope.histories, function(o) {
                    rows.push([$scope.companies.selected.name, o.Vehicle.number, o.datecreated, o.message, o.dddstate]);
                });

                var csvFile = '';
                for (var i = 0; i < rows.length; i++) {
                    csvFile += processRow(rows[i]);
                }

                var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
                if (navigator.msSaveBlob) {
                    navigator.msSaveBlob(blob, filename);
                } else {
                    var link = document.createElement('a');
                    if (link.download !== undefined) {
                        var url = URL.createObjectURL(blob);
                        link.setAttribute('href', url);
                        link.setAttribute('download', filename);
                        link.style.visibility = 'hidden';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            };

            function groupCompanySchedules(groups, schedules) {
                var list = {};
                angular.forEach(schedules, function(o) {
                    if (o.groupid !== null) {
                        var group =
                            $scope.scheduleGroups.list[o.groupid] !== void 0
                                ? $scope.scheduleGroups.list[o.groupid]
                                : o.groupid;
                        if (list[group] === void 0) {
                            list[group] = [];
                        }
                        list[group].push(o);
                    } else {
                        if (list['all'] === void 0) {
                            list['all'] = [];
                        }
                        list['all'].push(o);
                    }
                });
                return list;
            }

            function getCompanySchedules(company, vehicle) {
                $scope.loading = true;

                var endpoint = '/companies/' + company + '/schedules';
                if (vehicle) {
                    endpoint = '/companies/' + company + '/vehicles/' + vehicle.id + '/schedules';
                }

                return interceptor('get', endpoint).then(
                    function(response) {
                        var list = (response.data || {}).data;
                        list = list !== void 0 ? list : [];

                        list = list.filter(function(o) {
                            return !o.deleted;
                        });

                        list = assignShedulesVehicle($scope.vehicles.list, list).sort(function(a, b) {
                            var first =
                                (a.Vehicle || {}).stats !== void 0 ? a.Vehicle.stats.laststatedate : a.datecreated;
                            var second =
                                (b.Vehicle || {}).stats !== void 0 ? b.Vehicle.stats.laststatedate : b.datecreated;

                            if (first < second) {
                                return 1;
                            } else if (first > second) {
                                return -1;
                            }
                            return 0;
                        });
                        $scope.schedules.ungrouped = angular.copy(list);
                        $scope.schedules.list = groupCompanySchedules($scope.scheduleGroups.list, list);

                        var counter = 0;
                        for (var i in $scope.schedules.list) {
                            $scope.schedules.list[i] = $scope.schedules.list[i].map(function(o) {
                                o.counter = counter++;
                                return o;
                            });
                        }
                        $scope.loading = false;
                    },
                    function() {
                        $scope.loading = false;
                    }
                );
            }

            $scope.isShedulesEmpty = function() {
                return Object.keys($scope.schedules.list).length === 0;
            };

            $scope.onChangeCompany = function() {
                changeCompany($scope.companies.selected);
            };

            $scope.onChangeVehicleInShedules = function() {
                $scope.schedules.choose = {};
                getCompanySchedules($scope.companies.selected.id, $scope.filters.schedules.vehicle);
            };

            $scope.onChangeVehicleInFiles = function() {
                return getCompanyFiles().then(function() {
                    return applyCompanyFilesFilters();
                });
            };

            $scope.onChangeVehicle = function() {
                changeVehicle($scope.vehicles.selected);
            };

            function getCompanyScheduleGroups(company) {
                $scope.loading = true;
                return interceptor('get', '/companies/' + company + '/schedule_groups').then(
                    function(response) {
                        var list = (response.data || {}).data;
                        list = list !== void 0 ? list : [];

                        $scope.scheduleGroups.list = {};

                        list.forEach(function(o) {
                            $scope.scheduleGroups.list[o.id] = o.name;
                        });
                        $scope.loading = false;
                    },
                    function() {
                        $scope.loading = false;
                    }
                );
            }

            function applyCompanyFilesFilters() {
                $scope.filteredFiles = $scope.files.filter(function(file) {
                    var filters = $scope.filters.files;
                    var downloaded = moment(file.downloadtime).format('YYYY-MM-DD HH:mm');

                    if (filters.vehicle) {
                        if (file.vehicleid !== filters.vehicle.id) {
                            return false;
                        }
                    }

                    return filters.start < downloaded && downloaded < filters.end;
                });
            }

            function getCompanyFiles() {
                var deferred = $q.defer();

                if (!$scope.isTab($scope.FILES_TAB) || $scope.files.length > 0) {
                    deferred.resolve([]);
                    return deferred.promise;
                }

                var promises = [];

                for (var vehicle of $scope.vehicles.list) {
                    var counting = (vehicle.stats || {}).filecount;

                    if (counting !== void 0 && counting > 0) {
                        promises.push(vehicle.getFiles());
                    }
                }

                if (promises.length) {
                    $q.all(promises).then(function(data) {
                        $scope.files = data.reduce(function(prev, curr) {
                            return curr.concat(prev);
                        }, []);

                        deferred.resolve($scope.files);
                    });
                } else {
                    deferred.resolve([]);
                }

                return deferred.promise;
            }

            function getCompanies() {
                $scope.loading = true;

                return interceptor('get', '/companies').then(
                    function(response) {
                        var list = (response.data || {}).data;
                        list = list !== void 0 ? list : [];

                        $scope.companies.list = [];

                        list.forEach(function(o) {
                            $scope.companies.list.push(new Company(o));
                        });

                        $scope.loading = false;

                        if (list.length) {
                            return changeCompany($scope.companies.list[0]);
                        }
                    },
                    function(error) {
                        $scope.loading = false;
                        throw error;
                    }
                );
            }

            function getVehicles(company) {
                $scope.loading = true;
                var endpoint = '/companies/' + company + '/vehicles';

                return interceptor('get', endpoint).then(
                    function(response) {
                        var list = (response.data || {}).data;
                        list = list !== void 0 ? list : [];

                        $scope.vehicles.list = [];

                        list.map(function(o) {
                            $scope.vehicles.list.push(new Vehicle(o));
                        });

                        $scope.loading = false;

                        return $http.get('/api/harmonogram/states').then(function(response) {
                            var statuses = response.data.data;
                            $scope.vehicles.list.map(function(o) {
                                var num = o.number.toUpperCase().replace(/\s/g, '');
                                o.status = statuses[num] !== void 0 ? statuses[num] : 0;
                            });
                        });
                    },
                    function() {
                        $scope.loading = false;
                    }
                );
            }

            $scope.interval = null;
            $scope.$on('$destroy', function() {
                $timeout.cancel($scope.interval);
            });

            function updateStatuses() {
                if ($scope.vehicles.list && $scope.tab === $scope.LIST_TAB) {
                    var company = $scope.companies.selected;
                    getVehiclesStats(company.id).then(function() {});
                }
                $timeout.cancel($scope.interval);
                $scope.interval = $timeout(updateStatuses, REFRESH_TIME_IN_MILISECONDS);
            }

            function getStatuses() {
                return interceptor('get', '/statuses').then(
                    function(response) {
                        var statuses = response.data.data;

                        $scope.statuses = statuses;
                        $scope.statuses.sort(function(a, b) {
                            if (a.id > b.id) return 1;
                            if (b.id > a.id) return -1;

                            return 0;
                        });
                    },
                    function() {
                        return [];
                    }
                );
            }

            $scope.getVehicleStatus = function(status) {
                var variable = 'harmonograms.schedules.status.' + status;
                var translation = $translate.instant(variable);

                if (variable !== translation) {
                    return translation;
                }

                var founded = $scope.statuses.filter(function(o) {
                    return o.id === status;
                });

                return founded.length > 0 ? founded[0].name : null;
            };

            function getVehiclesStats(company) {
                var endpoint = '/companies/' + company + '/vehicles_stats';

                return interceptor('get', endpoint).then(
                    function(response) {
                        var stats = response.data.data;
                        $scope.vehicles.list.forEach(function(o) {
                            stats.forEach(function(v) {
                                if (o.id === v.vehicleid) {
                                    o.stats = v;
                                }
                            });
                        });

                        $scope.vehicles.list.sort(function(a, b) {
                            if (a.stats === void 0 || b.stats === void 0) {
                                return 0;
                            }
                            var a = typeof a.stats.laststatedate === 'string' ? '0' : a.stats.laststatedate;
                            var b = typeof b.stats.laststatedate === 'string' ? '0' : b.stats.laststatedate;

                            return a > b ? 1 : a < b ? -1 : 0;
                        });

                        return stats;
                    },
                    function() {
                        return [];
                    }
                );
            }

            function getVehicleFiles(company, vehicle) {
                var endpoint = '/companies/' + company + '/vehicles/' + vehicle + '/files';

                return interceptor('get', endpoint).then(
                    function(response) {
                        var list = (response.data || {}).data;
                        list = list !== void 0 ? list : [];

                        list.map(function(file) {
                            file.Vehicle = $scope.vehicles.list.find(function(v) {
                                return file.vehicleid === v.id;
                            });
                        });

                        list.sort((a, b) => {
                            return a.downloadtime > b.downloadtime ? -1 : 1;
                        });

                        $scope.loading = false;
                        return list;
                    },
                    function() {
                        return [];
                    }
                );
            }

            $scope.downloadFile = function(file) {
                var company = $scope.companies.selected;
                var endpoint =
                    '/api/harmonogram/companies/' +
                    company.id +
                    '/vehicles/' +
                    file.vehicleid +
                    '/files/' +
                    file.id +
                    '/download';

                window.open(window.location.protocol + '//' + window.location.hostname + endpoint, '_blank');
            };

            $scope.deleteVehicle = function(vehicle) {
                $scope.loading = true;

                var company = $scope.companies.selected;
                var endpoint = '/companies/' + company.id + '/vehicles/' + vehicle.id;
                return interceptor('put', endpoint, { vehicle: { disabled: true } }).then(
                    function() {
                        getVehicles(company.id).then(function() {
                            getVehiclesStats(company.id);
                        });
                        $scope.loading = false;
                    },
                    function() {
                        $scope.loading = false;
                    }
                );
            };

            function getSchedulePayload(payload, edition, company) {
                var objects = angular.copy(payload.objects);
                var body = angular.copy(payload.body);

                var multiple = objects.length > 1;

                if (multiple) {
                    body.vehicle_ids = objects;

                    return {
                        multiple_vehicle_schedule: body,
                    };
                }

                body.vehicleid = String(objects[0]);
                body.companyid = String(company.id);

                return {
                    schedule: body,
                };
            }

            function saveSchedule(payload, edition) {
                $scope.loading = true;

                var company = $scope.companies.selected;
                var endpoint = '';

                var dto = getSchedulePayload(payload, edition, company);

                if (payload.objects.length > 1) {
                    endpoint = '/companies/' + company.id + '/schedules';
                } else {
                    endpoint = '/companies/' + company.id + '/vehicles/' + payload.objects[0] + '/schedules';
                    endpoint += edition ? '/' + edition : '';
                }

                interceptor(edition ? 'put' : 'post', endpoint, dto).then(
                    function() {
                        $scope.loading = false;
                        getCompanySchedules($scope.companies.selected.id);
                    },
                    function() {
                        $scope.loading = false;
                    }
                );

                return true;
            }

            function getBlocksFromForm(form) {
                var value = 0;
                if (form.tachograph) {
                    value += 1;
                }
                for (var i = 1; i < 5; i++) {
                    if (form.blocks[i]) {
                        value += Math.pow(2, i);
                    }
                }
                if (form.card) {
                    value += 32;
                }
                return value;
            }

            function buildHarmonogramPayload(form, data) {
                form.object = form.object === void 0 ? [] : form.object;
                var objects = data.select
                    ? form.object.map(function(o) {
                          return o.id;
                      })
                    : Object.keys(data.selected);
                if (!objects.length) {
                    return false;
                }

                var duedate = moment(form.duedate)
                    .utc()
                    .format('YYYY-MM-DDTHH:mm:ss');
                var blocks = getBlocksFromForm(form);

                var body = {
                    disabled: form.disabled !== void 0 ? form.disabled : false,
                    deleted: false,
                    blocks: blocks,
                    period: form.period,
                    duedate: duedate,
                    groupid: form.groupid ? form.groupid : null,
                };

                if (form.blocks[1]) {
                    body.datefrom = moment(form.datefrom).format('YYYY-MM-DDTHH:mm:ss');
                    body.dateto = moment(form.dateto).format('YYYY-MM-DDTHH:mm:ss');
                }

                return {
                    objects: objects,
                    body: body,
                };
            }

            function init() {
                return getStatuses()
                    .then(
                        function() {
                            return getCompanies();
                        },
                        function() {
                            return getCompanies();
                        }
                    )
                    .then(function() {
                        updateStatuses();

                        return getCompanyFiles();
                    })
                    .then(function() {
                        return applyCompanyFilesFilters();
                    });
            }

            function buildVehiclePayload(form) {
                form.disabled = form.disabled ? true : false;
                form.companyid = $scope.companies.selected.id;

                return form;
            }

            function createVehicle(payload) {
                var company = $scope.companies.selected;
                var endpoint = '/companies/' + company.id + '/vehicles';

                $scope.loading = true;
                return interceptor('post', endpoint, {
                    vehicle: payload,
                    company_id: $scope.companies.selected.id,
                }).then(
                    function() {
                        getVehicles(company.id).then(function() {
                            getVehiclesStats(company.id);
                        });
                        $scope.loading = false;
                    },
                    function() {
                        $scope.loading = false;
                    }
                );
            }

            function saveFile(file) {
                var company = $scope.companies.selected;
                var endpoint =
                    '/api/harmonogram/companies/' +
                    company.id +
                    '/vehicles/' +
                    file.vehicleid +
                    '/files/' +
                    file.id +
                    '/download?save=1';

                return interceptor('get', endpoint);
            }

            function sendFile(payload) {
                var endpoint = `/rest-api/notification/resource?language=${csLanguage.get('lang')}`;

                return $http.post(endpoint, payload);
            }

            $scope.$watch('filters.vehicles.search', function(n, o) {
                $scope.vehicles.choose = {};
            });

            $scope.toggleChoose = function(type) {
                switch (type) {
                    case 'vehicles':
                        if (Object.keys($scope.vehicles.choose).length > 0) {
                            $scope.vehicles.choose = {};
                        } else {
                            var list = harmonogramSearch($scope.vehicles.list, $scope.filters.vehicles.search);
                            list.forEach(function(o) {
                                $scope.vehicles.choose[o.id] = true;
                            });
                        }
                        break;
                    case 'schedules':
                        if (Object.keys($scope.schedules.choose).length > 0) {
                            $scope.schedules.choose = {};
                        } else {
                            for (var key in $scope.schedules.list) {
                                if ($scope.schedules.list.hasOwnProperty(key)) {
                                    $scope.schedules.list[key].map(function(schedule) {
                                        $scope.schedules.choose[schedule.id] = true;
                                    });
                                }
                            }
                        }
                        break;
                    default:
                }
            };

            $scope.modals = {};
            $scope.objects = angular.copy($scope.extractObjectsBySelectedGroup(false, true));

            $scope.openSendFileModal = function(file) {
                var $isolated = $scope.$new(true);

                $ngConfirm({
                    title: $translate.instant('harmonograms.files.mail.title'),
                    contentUrl: 'tpl/pages/harmonograms/modals/files/mail.html',
                    theme: 'supervan',
                    columnClass: 'xl',
                    icon: 'pe-7s-mail',
                    scope: $isolated,
                    buttons: {
                        yes: {
                            text: $translate.instant('general.confirm.ok'),
                            btnClass: 'btn-info',
                            action: function(scope) {
                                var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                                if (!filter.test(scope.mail)) {
                                    return false;
                                }

                                saveFile(file)
                                    .then(function(response) {
                                        var payload = {
                                            email: scope.mail,
                                            type: 'schedule',
                                            react: false,
                                            link: response.data.data,
                                            description: 'ddd'
                                        };

                                        return sendFile(payload).then(function() {
                                            toaster.pop(
                                                'success',
                                                $translate.instant('general.toastr.success.header'),
                                                $translate.instant('harmonograms.toastr.success.send')
                                            );
                                        });
                                    })
                                    .catch(function() {
                                        toaster.pop(
                                            'error',
                                            $translate.instant('general.toastr.error.header'),
                                            $translate.instant('harmonograms.toastr.error.send')
                                        );
                                    });

                                return true;
                            },
                        },
                        no: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                            action: function() {},
                        },
                    },
                });
            };

            var loadTechnicalDataVehicles = function() {
                var deferred = $q.defer();

                if ($scope.technicals.loaded) {
                    deferred.resolve($scope.technicals.list);
                } else {
                    $http.get('/api/harmonogram/information').then(
                        function(response) {
                            var data = response.data.data;
                            $scope.technicals = {
                                list: data,
                                loaded: true,
                            };
                            deferred.resolve(data);
                        },
                        function() {
                            deferred.reject([]);
                        }
                    );
                }

                return deferred.promise;
            };

            $scope.openVehicleFormModal = function() {
                var $isolated = $scope.$new(true);

                $isolated.form = {
                    disabled: false,
                    smslogin: 'kksw',
                    smspassword: '2356',
                };
                $isolated.objects = [];

                loadTechnicalDataVehicles().then(
                    function(data) {
                        var mapped = $scope.vehicles.list.map(function(item) {
                            return item.number.toUpperCase().replace(/\s/g, '');
                        });

                        $isolated.objects = data.filter(function(item) {
                            var current = item.number.toUpperCase().replace(/\s/g, '');
                            return mapped.indexOf(current) < 0;
                        });
                    },
                    function() {}
                );

                $isolated.search = function(id) {
                    var founded = $scope.technicals.list.filter(function(item) {
                        return item.object === id;
                    });

                    if (!founded.length) {
                        return false;
                    }
                    founded = founded[0];

                    for (var p in founded) {
                        $isolated.form[p] = founded[p];
                    }
                    $isolated.form.number = founded.number.replace(/ /g, '').toUpperCase();
                    delete $isolated.form.object;
                };

                $ngConfirm({
                    title: $translate.instant('harmonograms.list.modals.form.title'),
                    contentUrl: 'tpl/pages/harmonograms/modals/vehicle/form.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'pe-7s-car pe-lg pe-va',
                    scope: $isolated,
                    buttons: {
                        yes: {
                            text: $translate.instant('general.confirm.save.ok'),
                            btnClass: 'btn-success',
                            action: function(scope) {
                                var payload = buildVehiclePayload(scope.form);
                                createVehicle(payload);

                                return true;
                            },
                        },
                        no: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            };

            $scope.openVehicleImportModal = function() {
                $ngConfirm({
                    title: $translate.instant('harmonograms.list.modals.import.title'),
                    contentUrl: 'tpl/pages/harmonograms/modals/vehicle/import.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'pe-7s-cloud-upload pe-lg pe-va',
                    scope: $scope,
                    buttons: {
                        yes: {
                            text: $translate.instant('general.confirm.ok'),
                            btnClass: 'btn-success',
                            action: function(scope) {
                                // save action
                                return true;
                            },
                        },
                        no: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            };

            $scope.openHarmonogramFormModal = function(choose, id) {
                var $isolated = $scope.$new(true);
                var edition = id !== void 0 ? id : false;

                $isolated.data = {
                    edition: edition,
                    list: angular.copy(
                        $scope.vehicles.list.map(function(o) {
                            return {
                                id: o.id,
                                label: o.number,
                                status: o.status,
                            };
                        })
                    ),
                    select: !edition && $scope.isEmptyObject(choose),
                    selected: getChooseObjects(choose, $scope.vehicles.list, 'id'),
                    settings: {
                        template:
                            '<span class="ms-object-status ms-object-status-{{ option.status }}"> {{ option.label }} </span>',
                    },
                    translations: {
                        buttonDefaultText: $translate.instant('multiselect.default'),
                        checkAll: $translate.instant('multiselect.check'),
                        uncheckAll: $translate.instant('multiselect.uncheck'),
                        dynamicButtonTextSuffix: $translate.instant('multiselect.checked'),
                    },
                };

                var now = moment();

                $isolated.form = {
                    object: [],
                    period: 1,
                    blocks: {},
                    duedate: now,
                    datefrom: moment(now),
                    dateto: moment(now),
                    group: null,
                };

                setDateRanges($isolated.form.duedate, $isolated.form.period);

                if (edition) {
                    var edited = $scope.schedules.ungrouped.filter(function(o) {
                        return Number(o.id) === Number(id);
                    });
                    if (edited.length) {
                        edited = angular.copy(edited[0]);

                        var blocks = {};
                        for (var i = 0; i < 6; i++) {
                            var is = $scope.isInBinarySet(i, edited.blocks);
                            blocks[i] = is;
                        }
                        $isolated.form.tachograph = blocks[5];
                        $isolated.form.blocks = {
                            1: blocks[4],
                            2: blocks[3],
                            3: blocks[2],
                            4: blocks[1],
                        };
                        $isolated.form.card = blocks[0];
                        $isolated.form.period = edited.period;
                        $isolated.form.disabled = edited.disabled;
                        $isolated.form.groupid = edited.groupid;

                        setDateRanges($isolated.form.duedate, $isolated.form.period);
                        $isolated.form.duedate = moment(edited.duedate).add(1, 'hours');

                        if (edited.datefrom) {
                            $isolated.form.datefrom = moment(edited.datefrom);
                        }

                        if (edited.dateto) {
                            $isolated.form.dateto = moment(edited.dateto);
                        }
                    }
                }

                function setDateRanges(date, n) {
                    var yesterday = moment(date).subtract(1, 'days');
                    var end = moment(yesterday).endOf('day');
                    var start = moment(date).startOf('day');

                    switch (n) {
                        case 1:
                        case 2:
                            start.subtract(1, 'days');
                            break;
                        case 4:
                            start.subtract(7, 'days');
                            break;
                        case 8:
                            start.subtract(14, 'days');
                            break;
                        case 16:
                            start.subtract(28, 'days');
                            break;
                        case 32:
                            start.subtract(1, 'months');
                            break;
                    }

                    $isolated.form.datefrom = start;
                    $isolated.form.dateto = end;
                }

                $isolated.$watch('form.period', function(n, o) {
                    if (n !== void 0 && n !== 1) {
                        setDateRanges($isolated.form.duedate, n);
                    }
                });

                $isolated.$watch('form.duedate', function(n, o) {
                    if (n !== void 0) {
                        setDateRanges(n, $isolated.form.period);
                    }
                });

                $isolated.onTachographChange = function() {
                    if (!$isolated.form.tachograph) {
                        [1, 2, 3, 4].map(function(i) {
                            delete $isolated.form.blocks[i];
                        });
                    }
                };

                $isolated.shouldShowDateRanges = function() {
                    return $isolated.form.blocks[1];
                };

                $isolated.shouldShowStaticRanges = function() {
                    return $isolated.form.period !== 1;
                };

                $ngConfirm({
                    title: $translate.instant('harmonograms.list.modals.harmonogram.' + (edition ? 'edit' : 'title')),
                    contentUrl: 'tpl/pages/harmonograms/modals/vehicle/harmonogram.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'pe-7s-date pe-lg pe-va',
                    scope: $isolated,
                    buttons: {
                        yes: {
                            text: $translate.instant('general.confirm.save.ok'),
                            btnClass: 'btn-success',
                            action: function(scope) {
                                var payload = buildHarmonogramPayload(scope.form, scope.data);
                                if (!payload) {
                                    toaster.error(
                                        $translate.instant('general.toastr.error.header'),
                                        $translate.instant('harmonograms.toastr.error.harmonograms.validation')
                                    );
                                    return false;
                                }
                                return saveSchedule(payload, edition);
                            },
                        },
                        no: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            };

            Vehicle.prototype.getFiles = function() {
                $scope.selectedFiles = {};
                $scope.selectedFilesAll = false;

                return getVehicleFiles($scope.companies.selected.id, this.id);
            };

            $scope.openVehicleHistoryModal = function(vehicle) {
                var $isolated = $scope.$new(true);

                var dates = false;
                var last = (vehicle.stats || {}).laststatedate;

                if (last !== void 0) {
                    var start = moment(last).startOf('day');
                    var end = moment(start).endOf('day');

                    dates = {
                        from: start.unix(),
                        to: end.unix(),
                    };
                }

                var promise = getVehicleHistories($scope.companies.selected, vehicle, dates);
                promise.then(function(list) {
                    $isolated.data = {
                        vehicle: vehicle,
                        histories: list,
                    };
                    $isolated.getVehicleStatus = $scope.getVehicleStatus;

                    $ngConfirm({
                        title: $translate.instant('harmonograms.list.modals.history.title'),
                        contentUrl: 'tpl/pages/harmonograms/modals/vehicle/history.html',
                        animation: 'rotate',
                        theme: 'supervan',
                        columnClass: 'large',
                        icon: 'pe-7s-file pe-lg pe-va',
                        scope: $isolated,
                        escapeKey: true,
                        backgroundDismiss: true,
                        buttons: {
                            ok: {
                                text: $translate.instant('general.confirm.ok'),
                                btnClass: 'btn-dark',
                                action: function() {
                                    return true;
                                },
                            },
                        },
                    });
                });
            };

            $scope.selectedFiles = {};
            $scope.selectedFilesAll = false;

            $scope.selectedFilesToggleAll = function(list) {
                $scope.selectedFilesAll = !$scope.selectedFilesAll;

                for (var i = 0; i < list.length; i++) {
                    var o = list[i];

                    if ($scope.selectedFilesAll) {
                        $scope.selectedFiles[o.id] = true;
                    } else {
                        delete $scope.selectedFiles[o.id];
                    }
                }
            };

            $scope.isSelectedFilesNotEmpty = function(list) {
                return Object.keys(list).length > 0;
            };

            $scope.downloadAllFiles = function(list, files) {
                var ids = [];

                for (var [key, value] of Object.entries(list)) {
                    if (value === true) {
                        ids.push(Number(key));
                    }
                }

                var filtered = files.filter((file) => ids.indexOf(file.id) >= 0);

                for (var file of filtered) {
                    $scope.downloadFile(file);
                }

                return true;
            };

            $scope.openVehicleFilesModal = function(vehicle) {
                var promise = vehicle.getFiles();
                var instance = null;

                promise.then(function(list) {
                    var $isolated = $scope.$new(true);

                    $isolated.data = {
                        list: list,
                    };

                    $isolated.isModal = true;

                    $isolated.selectedFiles = $scope.selectedFiles;
                    $isolated.selectedFilesAll = $scope.selectedFilesAll;

                    $isolated.selectedFilesToggleAll = $scope.selectedFilesToggleAll;
                    $isolated.isSelectedFilesNotEmpty = $scope.isSelectedFilesNotEmpty;
                    $isolated.downloadAllFiles = $scope.downloadAllFiles;

                    $isolated.isInBinarySet = $scope.isInBinarySet;
                    $isolated.downloadFile = $scope.downloadFile;
                    $isolated.openSendFileModal = $scope.openSendFileModal;

                    $isolated.close = function() {
                        instance.close();
                    };

                    instance = $ngConfirm({
                        title: $translate.instant('harmonograms.list.modals.files.title'),
                        contentUrl: 'tpl/pages/harmonograms/modals/vehicle/files.html',
                        animation: 'rotate',
                        theme: 'supervan',
                        columnClass: 'large',
                        icon: 'pe-7s-file pe-lg pe-va',
                        scope: $isolated,
                        buttons: {
                            yes: {
                                text: $translate.instant('general.confirm.ok'),
                                btnClass: 'btn-dark',
                                action: function() {
                                    $isolated.selectedFiles = {};
                                    $isolated.selectedFilesAll = false;

                                    return true;
                                },
                            },
                        },
                    });
                });
            };

            function deleteSingleSchedule(company, vehicle, schedule) {
                var endpoint = '/companies/' + company + '/vehicles/' + vehicle + '/schedules/' + schedule;
                return interceptor('put', endpoint, { schedule: { deleted: true } });
            }

            $scope.openDeleteConfirmation = function(name, cb, entry) {
                $ngConfirm({
                    title: $translate.instant('general.confirm.delete.title'),
                    content:
                        $translate.instant('general.confirm.delete.' + (name ? 'content' : 'many')) +
                        (name ? '<b> (' + name + ') </b>' : ''),
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'pe-7s-trash pe-lg pe-va',
                    scope: false,
                    buttons: {
                        yes: {
                            text: $translate.instant('general.confirm.delete.yes'),
                            btnClass: 'btn-danger',
                            action: function() {
                                cb(entry);
                                return true;
                            },
                        },
                        no: {
                            text: $translate.instant('general.confirm.delete.no'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            };

            $scope.deleteSchedules = function() {
                var schedules = $scope.schedules.choose;
                var promises = [];
                angular.forEach(Object.keys(schedules), function(item) {
                    var schedule = $scope.schedules.ungrouped.filter(function(o) {
                        return Number(o.id) === Number(item);
                    });
                    if (schedule.length) {
                        schedule = schedule[0];
                        promises.push(
                            deleteSingleSchedule($scope.companies.selected.id, schedule.vehicleid, schedule.id)
                        );
                    }
                });

                if (promises.length) {
                    $q.all(promises).then(function() {
                        getCompanySchedules($scope.companies.selected.id);
                    });
                }
            };

            $scope.openCardFormModal = function(card) {
                var $isolated = $scope.$new(true);
                var company = $scope.companies.selected;

                var expired = moment().endOf('year');

                $isolated.form = {};
                $isolated.company = company;

                if (card) {
                    $isolated.form = angular.copy(card);
                } else {
                    $isolated.form = {
                        companyid: company.id,
                        identificator: '',
                        comment: '',
                        disabled: false,
                        validuntil: expired,
                        appversion: '1.0.0',
                    };
                }

                $ngConfirm({
                    title: $translate.instant('harmonograms.cards.modals.form.' + (card ? 'edit' : 'create')),
                    contentUrl: 'tpl/pages/harmonograms/modals/card/form.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'pe-7s-id pe-lg pe-va',
                    scope: $isolated,
                    buttons: {
                        yes: {
                            text: $translate.instant('general.confirm.save.ok'),
                            btnClass: 'btn-success',
                            action: function(scope) {
                                return saveCompanyCard(scope.form);
                            },
                        },
                        no: {
                            text: $translate.instant('general.confirm.save.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            };

            function saveCompanyCard(form) {
                var company = $scope.companies.selected;
                var action = form.id ? 'put' : 'post';
                var endpoint = '/companies/' + company.id + '/cards' + (form.id ? '/' + form.id : '');

                return interceptor(action, endpoint, form).then(function() {
                    getCompanyCards(company.id);
                });
            }

            $scope.deleteCompanyCard = function(card) {
                return false;
            };

            function getCompanyCards(id) {
                return interceptor('get', '/companies/' + id + '/cards').then(function(response) {
                    $scope.cards = {
                        list: response.data.data,
                        loaded: id,
                    };
                });
            }

            $scope.hasAdministratorAccess = function() {
                return $scope.companies.list.length > 50;
            };

            init();
        },
    ]);

    function harmonogramSearch(items, st) {
        var filtered = [];
        angular.forEach(items, function(item) {
            if (item.number.indexOf(st) !== -1) {
                filtered.push(item);
            }
        });
        return filtered;
    }

    app.filter('harmonogramSearch', [
        function() {
            return harmonogramSearch;
        },
    ]);
})();
